// @flow strict

import type {
  ActionSource,
  ActionSourceChatbot,
  ABTEventsSchema,
  ABTPossibleRelations,
  ActionSourceVoicebot,
  ActionSourceSurveyV2,
} from 'src/types/audience-actions';
import type {AbtAttributesAction} from 'src/action-creators/action-based-targeting-meta';
import {
  RECEIVE_ABT_EVENTS,
  RECEIVE_ABT_RELATIONS,
  RECEIVE_JOURNEYS_ACTION,
  RECEIVE_CHATBOTS_ACTION,
  RECEIVE_WORKFLOWS_ACTION,
  RECEIVE_VOICEBOTS_ACTION,
  RECEIVE_SURVEY_V2_ACTION,
} from 'src/action-creators/audience-actions';


export type State = {
  events: ABTEventsSchema,
  relations: ABTPossibleRelations,
  sourceLimit: number,
  journeysMap: Map<string, Array<ActionSource>>,
  workflowsMap: Map<string, Array<ActionSource>>,
  chatbotsMap: Map<string, Array<ActionSourceChatbot>>,
  voicebotsMap: Map<string, Array<ActionSourceVoicebot>>,
  surveyV2Map: Map<string, Array<ActionSourceSurveyV2>>,
  totalJourneysCount: number,
  totalWorkflowsCount: number,
  totalChatbotsCount: number,
  totalVoicebotsCount: number,
  totalSurveyV2Count: number,
};

const initialState = {
  events: [],
  relations: {},
  sourceLimit: 0,
  journeysMap: new Map(),
  workflowsMap: new Map(),
  chatbotsMap: new Map(),
  voicebotsMap: new Map(),
  surveyV2Map: new Map(),
  totalJourneysCount: 0,
  totalChatbotsCount: 0,
  totalSurveyV2Count: 0,
  totalWorkflowsCount: 0,
  totalVoicebotsCount: 0,
};

export default (
  state: State = initialState,
  action: AbtAttributesAction,
): State => {
  switch (action.type) {
    case RECEIVE_ABT_EVENTS: {
      const {events, sourceLimit} = action.payload;
      return {
        ...state,
        events,
        sourceLimit,
      };
    }
    case RECEIVE_ABT_RELATIONS: {
      return {
        ...state,
        relations: action.payload,
      };
    }
    case RECEIVE_JOURNEYS_ACTION: {
      const {journeys, pageNumber, isNew} = action.payload;
      const tempJourneysMap = isNew ? new Map() : new Map(state.journeysMap);
      return {
        ...state,
        journeysMap: tempJourneysMap.set(pageNumber, journeys),
        totalJourneysCount: action.payload.totalCount,
      };
    }
    case RECEIVE_WORKFLOWS_ACTION: {
      const {workflows, pageNumber, isNew} = action.payload;
      const tempWorkflowsMap = isNew ? new Map() : new Map(state.workflowsMap);
      return {
        ...state,
        workflowsMap: tempWorkflowsMap.set(pageNumber, workflows),
        totalWorkflowsCount: action.payload.totalCount,
      };
    }
    case RECEIVE_CHATBOTS_ACTION: {
      const {chatbots, pageNumber, isNew, totalCount} = action.payload;
      const tempChatbotsMap = isNew ? new Map() : new Map(state.chatbotsMap);
      return {
        ...state,
        chatbotsMap: tempChatbotsMap.set(pageNumber, chatbots),
        totalChatbotsCount: totalCount,
      };
    }
    case RECEIVE_VOICEBOTS_ACTION: {
      const {voicebots, pageNumber, isNew, totalCount} = action.payload;
      const tempVoicebotsMap = isNew ? new Map() : new Map(state.voicebotsMap);
      return {
        ...state,
        voicebotsMap: tempVoicebotsMap.set(pageNumber, voicebots),
        totalVoicebotsCount: totalCount,
      };
    }
    case RECEIVE_SURVEY_V2_ACTION: {
      const {surveyV2, pageNumber, isNew, totalCount} = action.payload;
      const tempSurveyV2Map = isNew ? new Map() : new Map(state.surveyV2Map);
      return {
        ...state,
        surveyV2Map: tempSurveyV2Map.set(pageNumber, surveyV2),
        totalSurveyV2Count: totalCount,
      };
    }
  }
  return state;
};
